import {getStoreInfoByLocationV2} from 'services/location/location-service';
import {StoreInfo, UserAddress} from 'types';
import {is1PMakroStore} from 'utils';

class MultiStoreServiceClass {
  async getStoreInfoByLocation(
    zipcode: string,
    subdistrict: string,
    isExpress?: boolean,
    getAllStoresSorted?: boolean
  ): Promise<StoreInfo> {
    const stores = await getStoreInfoByLocationV2(zipcode, subdistrict);
    if (getAllStoresSorted) {
      return {
        ...stores,
        stores: stores?.stores?.filter((item) => !item.isExpress || item.isRegular),
        expressStores: stores?.stores?.filter((item) => item.isExpress)
      };
    }
    return {
      ...stores,
      stores: stores?.stores?.filter((item) => (isExpress ? item.isExpress : !item.isExpress || item.isRegular))
    };
  }

  async isLocationDeliverable(shippingAddress: UserAddress, isExpress?: boolean): Promise<boolean> {
    const storeInfo = await this.getStoreInfoByLocation(
      shippingAddress.zip,
      (shippingAddress.subDistrict?.nameEn || shippingAddress.subDistrict?.nameTh) as string,
      isExpress
    );
    return storeInfo.stores.some((store) => is1PMakroStore(store.storeCode));
  }
}

export const MultiStoreService = new MultiStoreServiceClass();
export default MultiStoreService;
